import { type Static, Type } from '@sinclair/typebox';

export const TurnstileVerifyTokenReplySchema = Type.Object({
  success: Type.Boolean(),
  challenge_ts: Type.Optional(Type.String()),
  hostname: Type.Optional(Type.String()),
  'error-codes': Type.Array(Type.String()),
  action: Type.Optional(Type.String()),
  cdata: Type.Optional(Type.String()),
  metadata: Type.Optional(Type.Any()),
});
export type TurnstileVerifyTokenReply = Static<typeof TurnstileVerifyTokenReplySchema>;

export const TurnstileVerifyTokenBodySchema = Type.Object({ token: Type.String() });
export type TurnstileVerifyTokenBody = Static<typeof TurnstileVerifyTokenBodySchema>;
